module.exports = __webpack_public_path__ + "static/media/reset.99d1cfc0.svg";